import baseAxios, { AxiosInstance } from 'axios';
import qs from 'querystring';
import { getEStoreToken, setEStoreToken, setExpiredTime } from '../utils/eStoreTokenUtils';

declare global {
  interface Window {
    REACT_APP_ESTORE_HOST: string;
  }
}

export const eStoreHost = window.REACT_APP_ESTORE_HOST || process.env.REACT_APP_ESTORE_HOST;

interface BaseAxios extends AxiosInstance {
  setToken?: (token?: string) => void
}

const axios: BaseAxios = baseAxios.create({
  baseURL: eStoreHost,
  paramsSerializer: (params) => qs.stringify(params),
});

axios.setToken = (token?: string) => {
  let tkn = getEStoreToken();
  if (token) {
    tkn = token;
    setEStoreToken(token);
    setExpiredTime(3600); // expire in 1 hour
  }
  if (tkn) {
    axios.defaults.headers['Authorization'] = `Bearer ${tkn}`;
  }
};

export { axios as eStoreAxios };
